@if (mode === 'renderer') {
<div class="force-container-type carousel-wrapper" [ngStyle]="{
      'margin-top.px': element.fields.marginTop,
      'margin-right.px': element.fields.marginRight,
      'margin-bottom.px': element.fields.marginBottom,
      'margin-left.px': element.fields.marginLeft,
      'padding-top.px': element.fields.paddingTop,
      'padding-right.px': element.fields.paddingRight,
      'padding-bottom.px': element.fields.paddingBottom,
      'padding-left.px': element.fields.paddingLeft,
      'background-color': element.fields.backgroundColor,
    }">
  <owl-carousel-o *ngIf="element?.fields?.imageCarouselItems?.length && showCarousel" [options]="owlCarouselOptions">
    <ng-container *ngFor="let item of element.fields.imageCarouselItems; let i = index">
      <ng-template carouselSlide>
        <div class="image-container-carousel">
          <img [src]="item.image || ('images/no-image.jpg' | gungImageUrl)" alt="Carousel Image"
            (click)="btnClick($event, item.link)"
            [ngStyle]="{ 'height.px': (element.fields.responsive ? undefined : element.fields.height) }">
        </div>
      </ng-template>
    </ng-container>
  </owl-carousel-o>
</div>
}

@if (mode === 'editor') {
<div class="editor">
  <lib-gung-tabset #ngbTab="gungTabset" justify="fill">
    <lib-gung-tab id="content">
      <ng-template libGungTabTitle>
        <div class="tab-title">
          <span>Content</span>
        </div>
      </ng-template>
      <ng-template libGungTabContent>
        <div class="row">
          <div class="col-12 mb-2">
            <div cdkDropList (cdkDropListDropped)="drop($event)" class="d-flex flex-column gap-3">
              <div *ngFor="let item of element.fields.imageCarouselItems; let i = index" cdkDrag
                class="d-flex flex-row image-carousel-item">
                <div class="image-carousel-item-drag-handle" cdkDragHandle>
                  <div class="dot-row">
                    <div class="dot"></div>
                    <div class="dot"></div>
                  </div>
                  <div class="dot-row">
                    <div class="dot"></div>
                    <div class="dot"></div>
                  </div>
                  <div class="dot-row">
                    <div class="dot"></div>
                    <div class="dot"></div>
                  </div>
                </div>

                <div class="image-carousel-item-inputs">
                  <div class="w-100 d-flex flex-row">
                    <lib-gung-text-input gungTranslate="IMAGE" [(ngModel)]="item.image"></lib-gung-text-input>
                    <button type="button" class="btn btn-outline-primary" (click)="uploadImage(i)">
                      <i class="fa-solid fa-upload"></i>
                    </button>
                  </div>

                  <lib-gung-text-input gungTranslate="LINK" [(ngModel)]="item.link"></lib-gung-text-input>
                </div>

                <div class="image-carousel-item-actions">
                  <button type="button" class="btn btn-danger" (click)="deleteCarouselItem(i)">
                    <i class="fa-solid fa-trash"></i>
                  </button>
                </div>
              </div>
            </div>

            <gung-button classes="btn-primary btn w-100 mt-3" label="{{ 'ADD_CAROUSEL_ITEM' | translate }}"
              [onClick]="addCarouselItem.bind(this)" />
          </div>
        </div>
      </ng-template>
    </lib-gung-tab>

    <lib-gung-tab id="styles">
      <ng-template libGungTabTitle>
        <div class="tab-title">
          <span>Styles</span>
        </div>
      </ng-template>
      <ng-template libGungTabContent>
        <lib-gung-accordion #acc="gungAccordion" [closeOthers]="false">
          <lib-gung-accordion-item [collapsed]="true">
            <ng-template libGungAccordionHeader>General Settings</ng-template>
            <ng-template libGungAccordionBody>
              <div class="row">
                <lib-dynamic-page-element-margin-padding [(marginTop)]="element.fields.marginTop"
                  [(marginRight)]="element.fields.marginRight" [(marginBottom)]="element.fields.marginBottom"
                  [(marginLeft)]="element.fields.marginLeft" [(paddingTop)]="element.fields.paddingTop"
                  [(paddingRight)]="element.fields.paddingRight" [(paddingBottom)]="element.fields.paddingBottom"
                  [(paddingLeft)]="element.fields.paddingLeft"></lib-dynamic-page-element-margin-padding>

                <div class="col-12">
                  <lib-gung-number-input [gungTranslate]="'HEIGHT'"
                    [(ngModel)]="element.fields.height"></lib-gung-number-input>
                </div>

                <div class="col-12">
                  <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" [(ngModel)]="element.fields.responsive"
                      id="responsive" />
                    <label class="form-check-label" for="responsive">Responsive</label>
                  </div>
                </div>

                <div class="col-12">
                  <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" [(ngModel)]="element.fields.autoplay"
                      id="autoplay" />
                    <label class="form-check-label" for="autoplay">{{ 'AUTOPLAY' | translate }}</label>
                  </div>
                </div>

                @if (element.fields.autoplay) {
                <div class="col-12">
                  <lib-gung-number-input [gungTranslate]="'AUTOPLAY_SPEED_SECONDS'"
                    [(ngModel)]="element.fields.autoplaySpeed"></lib-gung-number-input>
                </div>
                }

                <div class="col-12">
                  <div class="d-flex color-dp-input">
                    <lib-gung-text-input [gungTranslate]="'BACKGROUND'"
                      [(ngModel)]="element.fields.background"></lib-gung-text-input>
                    <input class="input-color" type="color" [(ngModel)]="element.fields.backgroundColor" />
                  </div>
                </div>
              </div>
            </ng-template>
          </lib-gung-accordion-item>
        </lib-gung-accordion>
      </ng-template>
    </lib-gung-tab>
  </lib-gung-tabset>
</div>
}

@if (mode === 'preview') {
<div class="preview-card-info d-flex align-items-center justify-content-between">
  <div class="preview-carousel-left d-flex align-items-center justify-content-center">
    <i class="fa-regular fa-chevron-left"></i>
  </div>
  <i class="fa-regular fa-image-landscape"></i>
  <div class="preview-carousel-right d-flex align-items-center justify-content-center">
    <i class="fa-regular fa-chevron-right"></i>
  </div>
</div>
}
